"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _areaOrderingActions = require("../areaordering/areaOrderingActions");
var _areaRegisterActions = require("../arearegister/areaRegisterActions");
var _areaSearchActions = require("../areasearch/areaSearchActions");
var _bizExclusionActions = require("../bizexclusion/bizExclusionActions");
var _buildingRegisterActions = require("../buildingregister/buildingRegisterActions");
var _buildingSearchActions = require("../buildingsearch/buildingSearchActions");
var _disasterRegisterActions = require("../disasterregister/disasterRegisterActions");
var _disasterSearchActions = require("../disastersearch/disasterSearchActions");
var _groupRegisterActions = require("../groupregister/groupRegisterActions");
var _groupSearchActions = require("../groupsearch/groupSearchActions");
var _hrLinkageSearchActions = require("../hrlinkagesearch/hrLinkageSearchActions");
var _rightusageActions = require("../rightusage/rightusageActions");
var _siteRegisterActions = require("../siteRegister/siteRegisterActions");
var _siteSearchActions = require("../siteSearch/siteSearchActions");
var _siteOrderingActions = require("../siteordering/siteOrderingActions");
var _masterdataConditionActions = require("./masterdataConditionActions");
var _bizUserRegisterActions = require("../bizuserregister/bizUserRegisterActions");
var _bizUserSearchActions = require("../bizusersearch/bizUserSearchActions");
var _bizUserCsvUploadActions = require("../bizusercsvupload/bizUserCsvUploadActions");
const masterdataReducers = {
  disasterSearch: _disasterSearchActions.disasterSearchReducer,
  disasterRegister: _disasterRegisterActions.disasterRegisterReducer,
  groupRegister: _groupRegisterActions.groupRegisterReducer,
  groupSearch: _groupSearchActions.groupSearchReducer,
  rightusage: _rightusageActions.rightusageReducer,
  bizExclusion: _bizExclusionActions.bizExclusionReducer,
  masterdataShareCondition: _masterdataConditionActions.masterdataConditionReducer,
  siteRegister: _siteRegisterActions.siteRegisterReducer,
  buildingRegister: _buildingRegisterActions.buildingRegisterReducer,
  buildingSearch: _buildingSearchActions.buildingSearchReducer,
  siteSearch: _siteSearchActions.siteSearchReducer,
  siteOrdering: _siteOrderingActions.siteOrderingReducer,
  areaSearch: _areaSearchActions.areaSearchReducer,
  areaRegister: _areaRegisterActions.areaRegisterReducer,
  areaOrdering: _areaOrderingActions.areaOrderingReducer,
  hrLinkageSearch: _hrLinkageSearchActions.hrLinkageSearchReducer,
  bizUserSearch: _bizUserSearchActions.bizUserSearchReducer,
  bizUserCsvUpload: _bizUserCsvUploadActions.bizUserCsvUploadReducer,
  bizUserRegister: _bizUserRegisterActions.bizUserRegisterReducer
};
var _default = exports.default = masterdataReducers;